import { TransactionTypeEnum } from "@/model/data/enums/TransactionTypeEnum";
import moment from "moment";

export class TransactionsFilterData {
    dateFilterType: number;
    startDate: Date;
    endDate: Date;
    transTypes: TransactionTypeEnum[];
    userId: string;
    userOrganization: string;
    userInfo: string;
    shiftNumber: string;
    channelId: string;
    serialNumber: string;
    loadIntegrationFeedback: boolean = true;
    startingTransactionId: string;
    endingTransactionId: string;
    envelopeId: string;
    bagId: string;

    constructor() {
        this.dateFilterType = 0;
        let startMoment = moment().subtract(5, "days");
        startMoment.hours(0);
        startMoment.minutes(0);
        startMoment.seconds(0);
        this.startDate = startMoment.toDate();

        let endMoment = moment();
        endMoment.hours(23);
        endMoment.minutes(59);
        endMoment.seconds(59);
        this.endDate = endMoment.toDate();
    }
}
